module.exports = function() {
  return new Worker(__webpack_public_path__ + "db524e4eb064795d94a5.worker.js");
};